// extracted by mini-css-extract-plugin
export default {"chartTitle":"EquipmentEnergyChartContainer_chartTitle__l1+aG"};